import { createServiceDropdown } from "./fancy-dropdowns.b78700ff08d2.js";
import CustomAmplitudeClient from "./custom-amplitude-client.0520d7b5cfdf.js";
import"./contact-us.80aa92b90d01.js";
import { MOBILE_SCREEN_QUERY } from "./shared.525ab500164c.js";

export class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.root = this.getRootNode();
    this.config = JSON.parse(
      this.root.querySelector("#page-config").textContent,
    );

    if (!this.config) throw new Error("unable to load page config");
    this.amplitudeClient = new CustomAmplitudeClient(this.config.analyticsUrl);
  }

  connectedCallback() {
    const searchBarContainer = this.root.querySelector(".search-bar");
    this.amplitudeClient.setupSearchBarAnalytics(searchBarContainer);

    const serviceCodeEl = this.root.querySelector("#service_code");
    this.serviceDropdown = createServiceDropdown(
      serviceCodeEl,
      this.config.servicesUrl,
      this.config.browseUrl,
    );

    this.serviceDropdown.on("change", this.advance);
    this.serviceDropdown.on("dropdown_close", () => {
      if (document.activeElement === this.serviceDropdown.control_input) {
        this.advance();
      }
    });
  }

  advance = () => {
    if (MOBILE_SCREEN_QUERY.matches) {
      document.activeElement?.blur();
    } else {
      this.root.getElementById("care-location").focus();
    }
  };
}

customElements.define("search-form", SearchForm);
